/**
 * Por qué la vista no puede mostrar flota. Los tres primeros llegan como
 * `data.code` del backend y se arreglan en pantallas distintas; el cuarto no es
 * un error sino un `200` con lista vacía.
 */
export type VansBlockedReason =
  | 'integration_disabled'
  | 'company_required'
  | 'scope_not_configured'
  | 'no_distributors'
  | 'generic';

/** Códigos del contrato que mapean a una pantalla de bloqueo propia. */
export const VANS_BLOCKED_REASON_BY_CODE: Record<string, VansBlockedReason> = {
  'company.tiendaPerfectaIntegrationDisabled': 'integration_disabled',
  'company.tiendaPerfectaCompanyRequiredWhenIntegrationEnabled':
    'company_required',
  'role.tiendaPerfectaScopeNotConfigured': 'scope_not_configured',
};

/** Colores de `estado.value`. Un valor desconocido cae al tag neutro. */
export const VAN_STATUS_COLORS: Record<string, string> = {
  disponible: 'green',
  en_taller: 'gold',
  inactivo: 'default',
};

/** Paleta para el avatar del tripulante, elegida por su id. */
export const CREW_AVATAR_COLORS = [
  '#722ed1',
  '#13c2c2',
  '#fa8c16',
  '#eb2f96',
  '#1677ff',
  '#52c41a',
];

export const getCrewAvatarColor = (seed: string): string => {
  const sum = Array.from(seed).reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return CREW_AVATAR_COLORS[sum % CREW_AVATAR_COLORS.length];
};

export const getInitials = (fullName: string): string =>
  fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
